import classNames from "classnames/bind";
import { RhLink } from "@components";
import { getLinkData } from "@/core/utils";
import { TopLevelNavigation } from "@header";

import styles from './TopLevelLink.module.scss';
const cx = classNames.bind(styles);

type LinkProps = TopLevelNavigation[number] & {
  active?: boolean;
};

export default function TopLevelLink({ link, active }: LinkProps) {
  const linkData = getLinkData(link);
  return (
    <RhLink href={linkData.url} target={linkData.target} className={cx(["top-level-link", "cta", { active }])} data-gtm-section="nav">
      <span className={cx("label")}>{linkData.label}</span>
    </RhLink>
  );
}